import React from 'react';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const StyledModalContainer = styled(Box)(() => ({
    width: '448px',
    backgroundColor: '#ffffff',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderTopWidth: '8px',
    borderTopStyle: 'solid',
    borderRadius: '3px 3px 0px 0px',
    padding: '32px 20px 20px 20px',
}));

interface OperatorModalProps {
    open: boolean;
    setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    Icon: React.FC<any>;
    headline: string;
    description: string;
    okayButtonLabel: string;
    cancelButtonLabel: string;
    customColor?: string;
    onClick?: () => void;
    loading?: boolean;
}

const OperatorModal: React.FC<OperatorModalProps> = ({
    open,
    setOpen,
    Icon,
    headline,
    description,
    okayButtonLabel,
    cancelButtonLabel,
    customColor,
    onClick,
    loading = false,
}) => {
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <StyledModalContainer sx={{ borderTopColor: customColor }}>
                <Container style={{ padding: 0 }}>
                    <Box
                        display={'grid'}
                        gap={'24px'}
                        padding={'20px'}
                        justifyContent={'center'}
                        justifyItems={'center'}
                    >
                        <Icon
                            color="primary"
                            fontSize="large"
                            sx={{ color: customColor }}
                        />
                        <Typography variant="h2">{headline}</Typography>
                        <Typography variant="body2" textAlign={'center'}>
                            {description}
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={onClick}
                            disabled={loading}
                            sx={{
                                padding: '12px 25px',
                                backgroundColor: customColor,
                                '&:hover': {
                                    backgroundColor: customColor,
                                },
                            }}
                        >
                            <Typography variant="h5" margin={0}>
                                {okayButtonLabel}
                            </Typography>
                        </Button>
                        <Button
                            onClick={handleClose}
                            disabled={loading}
                            sx={{
                                padding: '12px 25px',
                                color: 'gray',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            {cancelButtonLabel}
                        </Button>
                    </Box>
                </Container>
            </StyledModalContainer>
        </Modal>
    );
};

export default OperatorModal;
